import React, { FC, InputHTMLAttributes, useRef, forwardRef } from 'react'
import styled from 'styled-components'

export const labelHeight = 16
export const labelMarginBottom = 4
export const inputHeight = 40

export const StyledInput = styled.input<{
    $clickable?: boolean
    $width?: string
}>`
    height: ${inputHeight}px;
    width: ${(p) => p.$width};
    line-height: ${inputHeight}px;
    font-size: 16px;
    color: ${(p) => p.theme.colors.darkGrey};
    padding-left: 8px;
    padding-right: 8px;
    outline: none;
    border: ${(p) => `1px solid ${p.theme.colors.darkGrey}`};
    box-sizing: border-box;
    cursor: ${(p) => (p.$clickable ? 'pointer' : 'auto')};
    position: relative;

    &:focus {
        border: ${(p) => `1px solid ${p.theme.colors.primaryGreen}`};
    }

    &:disabled {
        border: 1px solid ${(p) => p.theme.colors.lighterGrey};
    }
`

const Label = styled.label`
    font-size: 13px;
    color: ${(p) => p.theme.colors.mediumGrey};
    margin-bottom: ${labelMarginBottom}px;
    height: ${labelHeight}px;
`

export const InputContainer = styled.div<{ $width?: string }>`
    display: flex;
    flex-direction: column;
    position: relative;
    width: ${(p) => p.$width ?? 'fit-content'};
`

export const Input = forwardRef<
    HTMLInputElement,
    InputHTMLAttributes<HTMLInputElement> & {
        $width?: string
        label?: string
    }
>((props, ref) => {
    return (
        <InputContainer $width={props.$width}>
            {props.label && <Label>{props.label}</Label>}
            <StyledInput ref={ref} $clickable={props.readOnly} {...props} />
        </InputContainer>
    )
})
